import {CountryBasedNumberModel, QuestionModel} from './question.model';
import {CountNumbersModel} from './subModels/countNumbers.model';
import {CountMultipleNumbersModel} from './subModels/countMultipleNumbers.model';
import {SingleAdditionModel} from './subModels/singleAddition.model';
import {SingleAdditionNeededAmountModel} from './subModels/singleAdditionNeededAmount.model';
import {DoubleAdditionModel} from './subModels/doubleAddition.model';
import {SingleSubtractionModel} from './subModels/singleSubtraction.model';
import {SingleSubtractionNeededAmountModel} from './subModels/singleSubtractionNeededAmount.model';
import {DoubleSubtractionModel} from './subModels/doubleSubtraction.model';
import {DescriptionModel} from '../shared/description.model';
import {SizeComparisonNumbersModel} from './subModels/sizeComparisonNumbers.model';
import {SizeComparisonSymbolsModel} from './subModels/sizeComparisonSymbols.model';
import {SizeComparisonWordsModel} from './subModels/sizeComparisonWords.model';
import {CountShapesModel} from './subModels/countShapes.model';
import {ShapeNameFromImageModel} from './subModels/shapeNameFromImage.model';
import {ShapeSingleDiscriminationCountModel} from './subModels/shapeSingleDiscriminationCount.model';
import {ImagePatternSingleFillModel} from './subModels/imagePatternSingleFill.model';
import {NumberPatternSingleFillModel} from './subModels/numberPatternSingleFill.model';
import {RepeatedAdditionModel} from './subModels/repeatedAddition.model';
import {UnitHouseModel} from './subModels/unitHouse.model';
import {SingleMultiplicationModel} from './subModels/singleMultiplication.model';
import {SingleDivisionModel} from './subModels/singleDivision.model';
import {CornerNameFromImageModel} from './subModels/cornerNameFromImage.model';
import {FractionSetupFromImageModel} from './subModels/fractionSetupFromImage.model';
import {ProportionsSetupFromImageModel} from './subModels/proportionsSetupFromImage.model';
import {Translation2DModel} from './subModels/translation2D.model';
import {PerimeterFromShapeModel} from './subModels/perimeterFromShapeModel';
import {AreaFromShapeModel} from './subModels/areaFromShape.model';
import {RoundingModel} from './subModels/rounding.model';
import {BarChartModel} from './subModels/barChart.model';
import {MeasurementComparisonModel} from './subModels/measurementComparison.model';
import {MeasurementInputModel} from './subModels/measurementInput.model';
import {Enums} from '../extensions/enums';
import {QuestionExtendedModel} from './question-extended.model';
import {SkillGroupBaseModel} from '../edu-admin/skillGroupBase.model';

export function generateQuestion(json: any): QuestionExtendedModel {

  const subCat = json.subCategory;
  const Subcategories = Enums.QuestionSubcategories;

  let q: QuestionExtendedModel = null;
  if (subCat === Subcategories.cornerNameFromImage) {
    q = CornerNameFromImageModel.generateModel(json);
  } else if (subCat === Subcategories.countNumbers) {
    q = CountNumbersModel.generateModel(json);
  } else if (subCat === Subcategories.countMultipleNumbers) {
    q = CountMultipleNumbersModel.generateModel(json);
  } else if (subCat === Subcategories.fractionSetupFromImage) {
    q = FractionSetupFromImageModel.generateModel(json);
  } else if (subCat === Subcategories.proportionSetupFromImage) {
    q = ProportionsSetupFromImageModel.generateModel(json);
  } else if (subCat === Subcategories.translation2D) {
    q = Translation2DModel.generateModel(json);
  } else if (subCat === Subcategories.singleAddition) {
    q = SingleAdditionModel.generateModel(json);
  } else if (subCat === Subcategories.singleAdditionNeededAmount) {
    q = SingleAdditionNeededAmountModel.generateModel(json);
  } else if (subCat === Subcategories.doubleAddition) {
    q = DoubleAdditionModel.generateModel(json);
  } else if (subCat === Subcategories.singleSubtraction) {
    q = SingleSubtractionModel.generateModel(json);
  } else if (subCat === Subcategories.singleSubtractionNeededAmount) {
    q = SingleSubtractionNeededAmountModel.generateModel(json);
  } else if (subCat === Subcategories.doubleSubtraction) {
    q = DoubleSubtractionModel.generateModel(json);
  } else if (subCat === Subcategories.sizeComparisonNumbers) {
    q = SizeComparisonNumbersModel.generateModel(json);
  } else if (subCat === Subcategories.sizeComparisonSymbols) {
    q = SizeComparisonSymbolsModel.generateModel(json);
  } else if (subCat === Subcategories.sizeComparisonWords) {
    q = SizeComparisonWordsModel.generateModel(json);
  } else if (subCat === Subcategories.countShapes) {
    q = CountShapesModel.generateModel(json);
  } else if (subCat === Subcategories.shapeNameFromImage) {
    q = ShapeNameFromImageModel.generateModel(json);
  } else if (subCat === Subcategories.shapeSingleDiscriminationCount) {
    q = ShapeSingleDiscriminationCountModel.generateModel(json);
  } else if (subCat === Subcategories.imagePatternSingleFill) {
    q = ImagePatternSingleFillModel.generateModel(json);
  } else if (subCat === Subcategories.numberPatternSingleFill) {
    q = NumberPatternSingleFillModel.generateModel(json);
  } else if (subCat === Subcategories.repeatedAddition) {
    q = RepeatedAdditionModel.generateModel(json);
  } else if (subCat === Subcategories.singleMultiplication) {
    q = SingleMultiplicationModel.generateModel(json);
  } else if (subCat === Subcategories.unitHouse) {
    q = UnitHouseModel.generateModel(json);
  } else if (subCat === Subcategories.singleDivision) {
    q = SingleDivisionModel.generateModel(json);
  } else if (subCat === Subcategories.perimeterFromShape) {
    q = PerimeterFromShapeModel.generateModel(json);
  } else if (subCat === Subcategories.areaFromShape) {
    q = AreaFromShapeModel.generateModel(json);
  } else if (subCat === Subcategories.roundingWholeNumber) {
    q = RoundingModel.generateModel(json);
  } else if (subCat === Subcategories.barChart) {
    q = BarChartModel.generateModel(json);
  } else if (subCat === Subcategories.measurementComparison) {
    q = MeasurementComparisonModel.generateModel(json);
  } else if (subCat === Subcategories.measurementInput) {
    q = MeasurementInputModel.generateModel(json);
  } else {
    q = new QuestionExtendedModel();
  }

  q._id = json._id;

  q.name = json.name;
  q.subject = json.subject;
  q.topic = json.topic;
  q.category = json.category;
  q.subCategory = json.subCategory;
  q.country = json.country;
  q.isStarterQuestion = json.isStarterQuestion;
  q.isArchived = json.isArchived;
  q.skillGroupId = json.skillGroupId;

  q.answerType = json.answerType;
  q.representation = json.representation;

  q.isPublished = json.isPublished;

  q.majorVersion = json.majorVersion;
  q.minorVersion = json.minorVersion;
  q.revisionVersion = json.revisionVersion;

  q.decidedRank = json.decidedRank;
  q.rank = json.rank;
  q.numCorrect = json.numCorrect;
  q.numWrong = json.numWrong;

  if (json.createdAt) {
    q.createdAt = new Date(json.createdAt);
  }

  if (json.updatedAt) {
    q.updatedAt = new Date(json.updatedAt);
  }

  if (json.names) {
    q.names = DescriptionModel.generateModel(json.names);
  }

  if (json.descriptions) {
    q.descriptions = DescriptionModel.generateModel(json.descriptions);
  }

  if (json.videoHelp) {
    q.videoHelp = DescriptionModel.generateModel(json.videoHelp);
  }

  if (json.audioHelp) {
    q.audioHelp = DescriptionModel.generateModel(json.audioHelp);
  }

  if (json.rankCountry) {
    q.rankCountry = CountryBasedNumberModel.generate(json.rankCountry);
  }

  if (json.numCorrectCountry) {
    q.numCorrectCountry = CountryBasedNumberModel.generate(json.numCorrectCountry);
  }

  if (json.numWrongCountry) {
    q.numWrongCountry = CountryBasedNumberModel.generate(json.numWrongCountry);
  }

  if (json.skillGroup) {
    q.skillGroup = SkillGroupBaseModel.generate(json.skillGroup);
  }


  return q;
}

export function generateQuestionList(jsonList: any[]): QuestionExtendedModel[] {

  const list = [];

  for (const json of jsonList) {
    const q = generateQuestion(json);
    list.push(q);
  }

  return list;

}

export function questionFromSubcategory(topic: string, category: string, subCat: string): QuestionExtendedModel {

  let q = new QuestionExtendedModel();

  if (subCat === Enums.QuestionSubcategories.cornerNameFromImage) {
    q = new CornerNameFromImageModel();
  } else if (subCat === Enums.QuestionSubcategories.countNumbers) {
    q = new CountNumbersModel();
  } else if (subCat === Enums.QuestionSubcategories.countMultipleNumbers) {
    q = new CountMultipleNumbersModel();
  } else if (subCat === Enums.QuestionSubcategories.fractionSetupFromImage) {
    q = new FractionSetupFromImageModel();
  } else if (subCat === Enums.QuestionSubcategories.proportionSetupFromImage) {
    q = new ProportionsSetupFromImageModel();
  } else if (subCat === Enums.QuestionSubcategories.translation2D) {
    q = new Translation2DModel();
  } else if (subCat === Enums.QuestionSubcategories.singleAddition) {
    q = new SingleAdditionModel();
  } else if (subCat === Enums.QuestionSubcategories.singleAdditionNeededAmount) {
    q = new SingleAdditionNeededAmountModel();
  } else if (subCat === Enums.QuestionSubcategories.doubleAddition) {
    q = new DoubleAdditionModel();
  } else if (subCat === Enums.QuestionSubcategories.singleSubtraction) {
    q = new SingleSubtractionModel();
  } else if (subCat === Enums.QuestionSubcategories.singleSubtractionNeededAmount) {
    q = new SingleSubtractionNeededAmountModel();
  } else if (subCat === Enums.QuestionSubcategories.doubleSubtraction) {
    q = new DoubleSubtractionModel();
  } else if (subCat === Enums.QuestionSubcategories.sizeComparisonNumbers) {
    q = new SizeComparisonNumbersModel();
  } else if (subCat === Enums.QuestionSubcategories.sizeComparisonSymbols) {
    q = new SizeComparisonSymbolsModel();
  } else if (subCat === Enums.QuestionSubcategories.sizeComparisonWords) {
    q = new SizeComparisonWordsModel();
  }  else if (subCat === Enums.QuestionSubcategories.countShapes) {
    q = new CountShapesModel();
  } else if (subCat === Enums.QuestionSubcategories.shapeNameFromImage) {
    q = new ShapeNameFromImageModel();
  } else if (subCat === Enums.QuestionSubcategories.shapeSingleDiscriminationCount) {
    q = new ShapeSingleDiscriminationCountModel();
  } else if (subCat === Enums.QuestionSubcategories.imagePatternSingleFill) {
    q = new ImagePatternSingleFillModel();
  } else if (subCat === Enums.QuestionSubcategories.numberPatternSingleFill) {
    q = new NumberPatternSingleFillModel();
  } else if (subCat === Enums.QuestionSubcategories.repeatedAddition) {
    q = new RepeatedAdditionModel();
  } else if (subCat === Enums.QuestionSubcategories.singleMultiplication) {
    q = new SingleMultiplicationModel();
  } else if (subCat === Enums.QuestionSubcategories.unitHouse) {
    q = new UnitHouseModel();
  } else if (subCat === Enums.QuestionSubcategories.singleDivision) {
    q = new SingleDivisionModel();
  } else if (subCat === Enums.QuestionSubcategories.perimeterFromShape) {
    q = new PerimeterFromShapeModel();
  } else if (subCat === Enums.QuestionSubcategories.areaFromShape) {
    q = new AreaFromShapeModel();
  } else if (subCat === Enums.QuestionSubcategories.roundingWholeNumber) {
    q = new RoundingModel();
  } else if (subCat === Enums.QuestionSubcategories.barChart) {
    q = new BarChartModel();
  } else if (subCat === Enums.QuestionSubcategories.measurementComparison) {
    q = new MeasurementComparisonModel();
  } else if (subCat === Enums.QuestionSubcategories.measurementInput) {
    q = new MeasurementInputModel();
  }

  q.topic = topic;
  q.category = category;
  q.subCategory = subCat;

  return q;

}
